// GENERATED BY scripts/ap-process-svg DO NOT EDIT
import { GeneratedIcon } from './Icon'
import type { GeneratedIconProps } from './Icon/types'
import Svg from './svg/icon-music.svg?react'

export const IconMusic = (props: GeneratedIconProps) => (
  <GeneratedIcon {...props}>
    <Svg preserveAspectRatio="xMidYMid meet" />
  </GeneratedIcon>
)

IconMusic.displayName = 'IconMusic'
